import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LocationsService } from '../locations/locations.service';
import { ResultsService } from '../results/results.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private readonly BASE_URL = environment.END_URL;
  private _locData: BehaviorSubject<any> = new BehaviorSubject('');
  private componentLoaded = new BehaviorSubject<boolean>(false);
  isUSA: any = false;
  encodedPrivacyHeader: string = btoa('privacyPolicy');

  constructor(
    private locationService: LocationsService,
    private resultsService: ResultsService
  ) {}

  getPrivacyPolicy() {
    let isPolicyAccepted = localStorage.getItem(this.encodedPrivacyHeader);
    if (isPolicyAccepted) {
      return atob(isPolicyAccepted) === 'true';
    } else {
      return false;
    }
  }

  setPrivacyPolicy(status: boolean) {
    localStorage.setItem(this.encodedPrivacyHeader, btoa(status.toString()));
  }

  getIsUSA() {
    return this.isUSA;
  }

  public get isUSALocation(): Observable<any> {
    return this._locData.asObservable();
  }

  checkUSALocation() {
    this.resultsService.getPublicIp().subscribe(
      (response: any) => {
        this.locationService.getPublicLocation(response.ip).subscribe(
          (item) => {
            if (item.country_name === 'United States') {
              this._locData.next(true);
              this.isUSA = true;
            } else {
              this._locData.next(false);
              this.isUSA = false;
            }
          },
          (err) => {
            this._locData.next(null);
            this.isUSA = null;
          }
        );
      },
      () => {
        this._locData.next(null);
        this.isUSA = null;
      }
    );
  }

  sendComponentLoadedSignal() {
    this.componentLoaded.next(true);
  }

  getComponentLoadedSignal(): Observable<boolean> {
    return this.componentLoaded.asObservable();
  }
}
